import React, { useState, useEffect } from "react";

import Axios from "axios";

import {
    MDBBtn,
    MDBTable,
    MDBTableHead,
    MDBTableBody,
    MDBModal,
    MDBModalDialog,
    MDBModalContent,
    MDBModalHeader,
    MDBModalTitle,
    MDBModalBody,
    MDBModalFooter,
    MDBTooltip,
} from "mdb-react-ui-kit";
import {Link, useParams, useNavigate} from "react-router-dom";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import {faDownload, faEye, faPen, faTrash} from "@fortawesome/free-solid-svg-icons";
import { saveAs } from "file-saver";
import Moment from 'moment';

import {
    ageRanges,
    backendPathEmployees,
    backendPathTasks,
    germanLevels,
    ratings,
    birthdayToAgeRange,
    backendPathCustomers
} from "../Constants";
import Uploader from "../components/Uploader";
import {loadPermissions} from "../functions/permissions";
import TopNavbar from "../components/Navbar";
import {canViewByExtension} from "../functions/visibility";


function Employee() {
    const { id } = useParams();
    const navigate = useNavigate();

    const [name, setName] = useState("");
    const [surname, setSurname] = useState("");
    const [birthday, setBirthday] = useState(Moment().format('YYYY-MM-DD'));
    const [phoneNumber, setPhoneNumber] = useState("");
    const [license, setLicense] = useState(0);
    const [smoker, setSmoker] = useState(0);
    const [germanLevel, setGermanLevel] = useState(0);
    const [actualGermanLevel, setActualGermanLevel] = useState(0);
    const [rating, setRating] = useState(0);
    const [ratingAnnotation, setRatingAnnotation] = useState("");
    const [recommendation, setRecommendation] = useState(0);
    const [taskAnnotation, setTaskAnnotation] = useState("");
    const [escalation, setEscalation] = useState("");
    const [annotation, setAnnotation] = useState("");
    const [inactive, setInactive] = useState(0);
    const [partner, setPartner] = useState("");
    const [nationality, setNationality] = useState("");

    const [tasks, setTasks] = useState([]);
    const [files, setFiles] = useState([]);
    const [deletionPopupVisible, setDeletionPopupVisible] = useState(false);

    const [writePermission, setWritePermission] = useState(false);
    const [readPermission, setReadPermission] = useState(false);


    const getEmployee = () => {
        Axios.get(`${backendPathEmployees}employee.php?id=${id}`).then((response) => {
            console.log(response.data);
            
            if (response.data.length === 0  ) {
                navigate("/404");
            }
            const employee = response.data[0];

            setName(employee.FirstName);
            setSurname(employee.LastName);
            setBirthday(employee.Birthday);
            setPhoneNumber(employee.PhoneNumber);
            setLicense(employee.License);
            setSmoker(employee.Smoker);
            setGermanLevel(employee.GermanLevel);
            setActualGermanLevel(employee.ActualGermanLevel);
            setRating(employee.Rating);
            setRatingAnnotation(employee.RatingAnnotation);
            setRecommendation(employee.Recommendation);
            setTaskAnnotation(employee.TaskAnnotation);
            setEscalation(employee.Escalations);
            setAnnotation(employee.Annotation);
            setInactive(employee.Inactive);
            setPartner(employee.PartnerName);
            setNationality(employee.Nationality);
        });
    };

    const getTasks = () => {
        Axios.get(`${backendPathTasks}tasks-of-employee.php?id=${id}`).then((response) => {
            setTasks(response.data);
            console.log(response.data);
        });
    };

    const getFiles = () => {
        Axios.get(`${backendPathEmployees}employee-files.php?id=${id}`).then((response) => {
            setFiles(response.data);
            console.log(files);
        });
    }

    const toggleShow = () => setDeletionPopupVisible(!deletionPopupVisible);

    const deleteEmployee = () => {
        Axios.get(`${backendPathEmployees}delete-employee.php?id=${id}`).then((response) => {
            navigate("/employees",);
        });
    };

    const deleteFile = (filename) => {
        Axios.get(`${backendPathEmployees}employee-delete-file.php?id=${id}&name=${filename}`).then((response) => {
            console.log("deleted " + filename);
            getFiles();
        });
    };

    const editEmployee = () => {
        navigate("/edit-employee/" + id,);
    };


    const openFileInNewTab = async (filename) => {

        try {
            const response = await fetch(`${backendPathEmployees}get-employee-file.php?id=${id}&filename=${encodeURIComponent(filename)}`, {
                method: 'GET'
            });

            if (!response.ok) {
                throw new Error('File download failed!');
            }

            const blob = await response.blob();
            const fileURL = URL.createObjectURL(blob);
            console.log("file success");

            // Open in new tab
            window.open(fileURL, '_blank');
            URL.revokeObjectURL(fileURL); // Optional cleanup
        } catch (error) {
            console.error('Error opening file:', error);
        }
    };

    const downloadFile = async (filename) => {
        try {
            const response = await fetch(`${backendPathEmployees}get-employee-file.php?id=${id}&filename=${encodeURIComponent(filename)}`, {
                method: 'GET'
            });

            if (!response.ok) {
                throw new Error('File download failed!');
            }

            const blob = await response.blob();
            saveAs(blob, filename);
        } catch (error) {
            console.error('Error opening file:', error);
        }
    }

    useEffect(() => {
        loadPermissions(navigate, setReadPermission, setWritePermission);
    }, []);

    useEffect(() => {
        getEmployee();
    }, [id]);

    useEffect(() => {
        getTasks();
    }, [name]);

    useEffect(() => {
        getFiles();
    }, [name]);

    return (
        <>
        <TopNavbar readPermissionInitial={readPermission} writePermissionInitial={writePermission}/>
        <div className='main'>
            <div className='header'>
                <h2>{name} {surname} {inactive ? "(inaktiv)" : ""}</h2>
                <div className='btns'>
                    <MDBBtn className="btn delete" onClick={toggleShow}>
                        Löschen
                    </MDBBtn>
                    <MDBBtn className="btn" onClick={editEmployee}>
                        <FontAwesomeIcon className='btn-icon' icon={faPen} />
                        Bearbeiten
                    </MDBBtn>
                    <MDBBtn className="btn" onClick={() => {navigate(`/new-task?employeeId=${id}`)}}>
                        Einsatz planen
                    </MDBBtn>
                </div>
            </div>

            <MDBTable align='middle'>
                <tbody>
                <tr>
                    <th>Alter</th>
                    <td>{ageRanges[birthdayToAgeRange(birthday)].label}</td>
                </tr>
                <tr>
                    <th>Nationalität</th>
                    <td>{nationality}</td>
                </tr>
                <tr>
                    <th>Telefon</th>
                    <td>{phoneNumber}</td>
                </tr>
                <tr>
                    <th>Partner</th>
                    <td>{partner ? partner : "-"}</td>
                </tr>
                <tr>
                    <th>Führerschein vorhanden</th>
                    <td>{license ? 'ja' : 'nein'}</td>
                </tr>
                <tr>
                    <th>Raucher/in</th>
                    <td>{smoker ? 'ja' : 'nein'}</td>
                </tr>
                <tr>
                    <th>angegebene Deutschkenntnisse</th>
                    <td>{germanLevels[germanLevel].label}</td>
                </tr>
                <tr>
                    <th>tatsächliche Deutschkenntnisse</th>
                    <td>{actualGermanLevel >= 0 ? germanLevels[actualGermanLevel].label : "-"}</td>
                </tr>
                <tr>
                    <th>Bewertung</th>
                    <td>{rating >= 0 ? ratings[rating].label : "-"}</td>
                </tr>
                <tr>
                    <th>Bemerkung zu der Bewertung</th>
                    <td>{ratingAnnotation ? ratingAnnotation : '-'}</td>
                </tr>
                <tr>
                    <th>für erneute Einsätze empfohlen</th>
                    <td>{recommendation ? 'ja' : 'nein'}</td>
                </tr>
                <tr>
                    <th>Bemerkung für erneute Einsätze</th>
                    <td>{taskAnnotation ? taskAnnotation : '-'}</td>
                </tr>
                <tr>
                    <th>Eskalationen</th>
                    <td>{escalation ? escalation : '-'}</td>
                </tr>
                <tr>
                    <th>Notizen</th>
                    <td>{annotation ? annotation : '-'}</td>
                </tr>
                </tbody>
            </MDBTable>

            <h3>Dateiablage</h3>

            {
                files.length ?
                    <MDBTable align='middle'>
                    <MDBTableHead>
                        <tr>
                            <th scope='col'>Dateiname</th>
                            <th scope='col'>Änderungsdatum</th>
                            <th scope='col'></th>
                        </tr>
                    </MDBTableHead>
                    <MDBTableBody>
                        {files.map((val, key) => {
                            return (
                                <tr key={key}>
                                    <td>{val.name}</td>
                                    <td>{val.date}</td>
                                    <td style={{textAlign: "right"}}>
                                        <MDBTooltip tag='a' title="ansehen">
                                            <FontAwesomeIcon
                                                hidden={!canViewByExtension(val.name)}
                                                className='btn-icon trash-btn' icon={faEye} onClick={
                                                () => {
                                                    openFileInNewTab(val.name).then(r => console.log(r));
                                                }}/>
                                        </MDBTooltip>

                                        <MDBTooltip tag='a' title="herunterladen">
                                            <FontAwesomeIcon className='btn-icon trash-btn ms-4' icon={faDownload}
                                                             onClick={() => {
                                                                 downloadFile(val.name).then(r => console.log(r));
                                                             }}/>
                                        </MDBTooltip>

                                        <MDBTooltip tag='a' title="löschen">
                                            <FontAwesomeIcon className='btn-icon trash-btn ms-4' icon={faTrash}
                                                             onClick={() => {
                                                                 deleteFile(val.name);
                                                             }}/>
                                        </MDBTooltip>
                                    </td>
                                </tr>
                            );
                        })}
                    </MDBTableBody>
                    </MDBTable>
                    : null
            }

            <p className="input-label" style={{marginTop: 32}}>neue Dateien hochladen</p>
            <Uploader personalId={id} personType={"employee"} refresh={getFiles} onClick={getFiles}></Uploader>

            <h3>Einsatzhistorie</h3>

            <MDBTable align='middle'>
                <MDBTableHead>
                    <tr>
                        <th scope='col'>Zeitraum</th>
                        <th scope='col'>Kunde/in</th>
                        <th scope='col'>Anmerkung</th>
                    </tr>
                </MDBTableHead>
                <MDBTableBody>
                    {tasks.map((val, key) => {
                        return (
                            <tr key={key}>
                                <td>{Moment(val.StartDate, "YYYY-MM-DD").format("DD.MM.YYYY")} - {Moment(val.EndDate, "YYYY-MM-DD").format("DD.MM.YYYY")}</td>
                                <td>
                                    <Link to={"/customer/" + val.CustomerID}>{val.FirstNameC} {val.LastNameC}</Link>
                                </td>
                                <td>{val.annotation ? val.annotation : "-"}</td>
                            </tr>
                        );
                    })}
                </MDBTableBody>
            </MDBTable>

            <MDBModal show={deletionPopupVisible} setShow={setDeletionPopupVisible} tabIndex="-1">
                <MDBModalDialog>
                    <MDBModalContent>
                        <MDBModalHeader>
                            <MDBModalTitle>{name} {surname} löschen</MDBModalTitle>
                            <MDBBtn
                                className="btn-close"
                                color="none"
                                onClick={toggleShow}
                    ></MDBBtn>
                    </MDBModalHeader>
                    <MDBModalBody>Wenn die Betreuungskraft gelöscht wird, werden auch alle Sie betreffenden Einsätze gelöscht.</MDBModalBody>

                    <MDBModalFooter>
                    <MDBBtn className="btn-light" onClick={toggleShow}>
                        Abbrechen
                    </MDBBtn>
                    <MDBBtn onClick={deleteEmployee}>Löschen</MDBBtn>
                    </MDBModalFooter>
                </MDBModalContent>
                </MDBModalDialog>
            </MDBModal>
        </div>
        </>
    );
}

export default Employee;